import { render, staticRenderFns } from "./SendJoinInvitesCollector.vue?vue&type=template&id=31336097&scoped=true"
import script from "./SendJoinInvitesCollector.vue?vue&type=script&lang=js"
export * from "./SendJoinInvitesCollector.vue?vue&type=script&lang=js"
import style0 from "./SendJoinInvitesCollector.vue?vue&type=style&index=0&id=31336097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31336097",
  null
  
)

export default component.exports